import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { DatePicker, DatePickerProps, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';

import DateTime, { defaultDateFormat } from 'utils/date';

interface CustomDatePickerFormikProps {
  name: string;
  value: DateTime | null;
  onChange: (date) => void;
  format?: string;
  error?: boolean;
  helperText?: string;
  inputProps?: TextFieldProps['inputProps'];
  textFieldProps?: TextFieldProps;
}

const CustomDatePickerFormik = ({
  name,
  value,
  format = defaultDateFormat,
  onChange,
  error,
  helperText,
  inputProps,
  textFieldProps,
  ...restProps
}: Partial<DatePickerProps<DateTime, DateTime>> & CustomDatePickerFormikProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="pt-br">
      <DatePicker
        {...(restProps as DatePickerProps<DateTime, DateTime>)}
        mask="__/__/____"
        value={value}
        onChange={(date) => onChange(date)}
        inputFormat={format}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            error={error}
            helperText={helperText}
            name={name}
            {...textFieldProps}
            inputProps={{ ...params.inputProps, ...inputProps }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePickerFormik;
